import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

export const useError = () => {
  const location = useLocation()
  const [errorMessage, setErrorMessage] = useState('')

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const message =
      params.get('message') ||
      'Por favor, tente novamente. Se o problema persistir, entre em contato com o nosso suporte.'

    setErrorMessage(message)
  }, [location.search])

  return { errorMessage }
}
